import request from "@/utils/request";

export function getBrandList(params) {
  return request({ url: "/storeBrand/list", method: "get", params });
}
